import { gsap } from 'gsap';

export function fadeInOnScroll(elements) {
  elements.forEach(el => {
    gsap.from(el, {
      scrollTrigger: {
        trigger: el,
        start: 'top bottom',
      },
      opacity: 0,
      translateY: 50,
      ease: 'power1.out',
      duration: 1,
    });
  });
}

document.addEventListener('DOMContentLoaded', () => {

  // Animate some elements fading in on scroll
  fadeInOnScroll(
    document.querySelectorAll('.fade-in-children > *')
  );

  // Add .is-scrolled-in class to some elements when they reach the viewport
  document.querySelectorAll('.hero').forEach(el => {
    gsap.timeline({
      scrollTrigger: {
        trigger: el,
        start: 'top bottom',
        once: true,
        toggleClass: 'is-scrolled-in'
      },
    });
  });

});
